import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Button from '@atoms/Button/Button';
import Title from '@atoms/Title/Title';
import CardWithBackground from '../Card/CardWithBackground';
import './HeaderSubCard.scss';
import { useLocale } from '@hooks';
import { graphql, useStaticQuery } from 'gatsby';


const HeaderSubCard = () => {
    const { t } = useTranslation();
    const { getAppLinkWithCurrentLang } = useLocale();

    const how_to_start_image = useStaticQuery(graphql`
        query {
            howToStart: file(name: {eq: "dont-know-how-to-start"}) {
                name
                childImageSharp {
                    fluid(maxWidth: 250, quality: 80) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
        }
    `);

    return (
        <div className="HeaderSubCard">
            <CardWithBackground
                urlSharp={how_to_start_image.howToStart}
                altText={how_to_start_image.howToStart.name}
                greenBackground
            >
                <Title size="l" font="alt">
                    {t('nav.cta.mini.block.label')}
                </Title>
                <a
                    href={getAppLinkWithCurrentLang(
                        process.env.GATSBY_START_FULL_FUNNEL_URL
                    )}
                >
                    <Button
                        label={t('nav.cta.mini.block.cta')}
                        theme="pink-gradient"
                        isFullsize
                    />
                </a>
            </CardWithBackground>
        </div>
    );
};

export default HeaderSubCard;
